var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.906 5.012C17.648 3.113 14.16 3.398 12 5.598c-2.16-2.2-5.648-2.489-7.906-.586-2.938 2.472-2.508 6.504-.414 8.64l6.851 6.98a2.05 2.05 0 0 0 2.938.005l6.851-6.98c2.09-2.137 2.528-6.169-.414-8.645m-.922 7.324-6.851 6.98c-.094.094-.172.094-.266 0l-6.851-6.98C3.59 10.883 3.3 8.133 5.3 6.449c1.52-1.277 3.863-1.086 5.332.41L12 8.254l1.367-1.395c1.477-1.504 3.82-1.687 5.332-.414 1.996 1.684 1.7 4.45.285 5.89"
  })));
};
export default SvgHeart;